import axios from "axios";

// Thin wrappers over /admin/auth. Every call resolves to the response body
// (which carries `status` and `message`), including 4xx responses, so pages
// can show the server's message. Network failures reject.
const call = (method, url, data) =>
  axios({ method, url, data })
    .then((res) => res.data)
    .catch((error) => {
      if (error.response?.data) return error.response.data;
      throw error;
    });

export const authApi = {
  login: (username, password, deviceToken) =>
    call("post", "admin/auth/login", { username, password, deviceToken }),
  verifyMfa: (challenge, { code, rememberDevice }) =>
    call("post", "admin/auth/mfa", { challenge, code, rememberDevice }),
  setInitialPassword: (ticket, temporaryPassword, newPassword) =>
    call("post", "admin/auth/password/initial", {
      ticket,
      temporaryPassword,
      newPassword,
    }),
  setupAuthenticator: (ticket, code) =>
    call("post", "admin/auth/authenticator/setup", { ticket, code }),
  me: () => call("get", "admin/auth/me"),
  logout: () => call("post", "admin/auth/logout"),
  sessions: () => call("get", "admin/auth/sessions"),
  revokeSession: (sessionId) =>
    call("delete", `admin/auth/sessions/${sessionId}`),
  revokeAllSessions: () => call("post", "admin/auth/sessions/revoke-all"),
  changePassword: (payload) => call("post", "admin/auth/password", payload),
  startMfaChange: (payload) =>
    call("post", "admin/auth/mfa/change/start", payload),
  completeMfaChange: (ticket, code) =>
    call("post", "admin/auth/mfa/change/complete", { ticket, code }),
};

// "Don't ask for the code on this device for 7 days": one token per username,
// kept in this browser only. The server decides whether it is still valid.
const TRUSTED_DEVICES = "ADMIN_TRUSTED_DEVICES";
const readTrusted = () => {
  try {
    return JSON.parse(localStorage.getItem(TRUSTED_DEVICES) || "{}");
  } catch (error) {
    return {};
  }
};
export const trustedDevice = {
  get: (username) =>
    readTrusted()[
      String(username || "")
        .trim()
        .toLowerCase()
    ],
  set: (username, token) => {
    const all = readTrusted();
    all[
      String(username || "")
        .trim()
        .toLowerCase()
    ] = token;
    localStorage.setItem(TRUSTED_DEVICES, JSON.stringify(all));
  },
  forget: (username) => {
    const all = readTrusted();
    delete all[
      String(username || "")
        .trim()
        .toLowerCase()
    ];
    localStorage.setItem(TRUSTED_DEVICES, JSON.stringify(all));
  },
};
